<div>
  <button id="FeedbackAttachments_Button_Close" type="button" class="close" data-dismiss="modal" aria-label="Close" tabindex="-1" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>

  <div class="modal-header d-block">
    <div class="title-of-box-hold">
      <div class="title-of-box">
        Attach {{mode === 'single' ? "File" : "Files"}}
      </div>
    </div>
  </div>

  <div class="modal-body">
    @for (attachment of attachments; track attachment; let i = $index) {
      <div class="pb-2">
        <button id="FeedbackAttachments_Button_Browse_{{i}}" class="btn btn-default yellow-btn" (click)="fileInput.click();">Browse</button>
        <span class="ps-2">{{ attachment.name || 'Choose file...'}}</span>
        <input name="FeedbackAttachments_Attachment_{{i}}" id="FeedbackAttachments_Attachment_{{i}}" type="file" class="invisible" #fileInput (change)="fileChanged(fileInput.files, attachment)">
      </div>
    }
  </div>

  <div class="modal-footer">
    @if (mode === 'multiple') {
      <button id="FeedbackAttachments_Button_AddFile" type="button" class="btn btn-default yellow-btn" (click)="addFile()">Add File</button>
    }
    <button id="FeedbackAttachments_Button_AttachFiles" type="submit" class="btn btn-default yellow-btn" (click)="attachFiles()">Attach {{mode === 'single' ? "File" : "Files"}}</button>
    <button id="FeedbackAttachments_Button_Cancel" type="button" class="btn btn-default yellow-btn" (click)="closeModal()">Cancel</button>
  </div>
</div>
